import { render, staticRenderFns } from "./InlineBoxIndicator.vue?vue&type=template&id=024ab87d"
import script from "./InlineBoxIndicator.vue?vue&type=script&lang=js"
export * from "./InlineBoxIndicator.vue?vue&type=script&lang=js"
import style0 from "./InlineBoxIndicator.vue?vue&type=style&index=0&id=024ab87d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports